import { colors } from '@globals/themes/defaultTheme'
import { Recognition } from '@kudos/http-client'
import Box from '@mui/material/Box'
import DisplayOnlyChipList from '@shared/components/DisplayOnlyChipList'
import React from 'react'
import ScrollingContent from '../ScrollingContent'

type TvRecognitionContentProps = {
  recognition: Recognition
}

const TvRecognitionContent: React.FC<TvRecognitionContentProps> = ({ recognition }) => {
  return (
    <ScrollingContent
      htmlContent={recognition.message}
      maxHeight="70vh"
      contentSx={{ color: colors.grayPrimary, fontSize: '2.5rem', pb: 4 }}
      attachmentUrls={recognition.attachmentUrls}
      gifs={recognition.gifs}>
      <Box sx={{ pt: 4, pb: 4 }}>
        <DisplayOnlyChipList options={recognition.qualities} />
      </Box>
    </ScrollingContent>
  )
}

export default TvRecognitionContent
